/* eslint-disable react/prop-types */
import { useState } from "react";
import SoftBox from "components/SoftBox";
import { Icon, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import { JournalVoucher5Service } from "services/journal-voucher-5";
import { toast } from "react-toastify";

function ActionCell({ item }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }} onClick={handleOpenMenu}>
        <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
      </SoftBox>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} keepMounted>
        <MenuItem component={Link} to={item.viewLink}>
          Xem chi tiết
        </MenuItem>
      </Menu>
    </SoftBox>
  );
}

export default ActionCell;
